module.exports = __webpack_public_path__ + "static/media/42.f9f679a3.mp3";